/* Dutch Language File */

var currentlanguage = 'nl';

+function ($) {

	/* Dutch translation for the jQuery dataTable Addon */
	if ('undefined' !== typeof $.fn.dataTable) {
		$.extend( true, $.fn.dataTable.defaults, {
			"oLanguage": {
				'sProcessing':'Bezig...',
				'sLengthMenu':'Resultaten per pagina: _MENU_',
				'sZeroRecords':'Geen resultaten gevonden',
				'sInfo':'_START_ tot _END_ van _TOTAL_ resultaten',
				'sInfoEmpty':'Geen resultaten om weer te geven',
				'sInfoFiltered':' (gefilterd uit _MAX_ resultaten)',
				'sInfoPostFix':'',
				'sSearch':'Zoeken:',
				'sEmptyTable':'Geen resultaten aanwezig in de tabel',
				'sInfoThousands':'.',
				'sLoadingRecords':'Een moment geduld aub - bezig met laden...',
				'oPaginate':{
					'sFirst':'Eerste',
					'sLast':'Laatste',
					'sNext':'Volgende',
					'sPrevious':'Vorige'
				}
			}
		});
	}

	// Extra APT validator translations
	if ('undefined' !== typeof $.validator) $.extend($.validator.messages, {
		// Extra for apt
		credit_limit: "De credit limit moet tussen de 250k en 150M liggen.",
		grace_holiday_period: "De grace period moet kleiner zijn dan de term.",
		term_grace_leasing: "De term minus de grace period moet een veelvoud zijn van de payment frequency.",
		max_term_leasing: "De term minus de grace period mag niet hoger zijn dan 240 maanden (20 jaar).",
		max_term_factoring: "De term mag niet hoger zijn dan 1200 maanden (100 jaar).",
		net_principal_amount: "De som van de down payment en de residual value moet lager zijn dan de net principle amount.",
		zero: "Dit veld moet groter zijn dan nul."
	});

}(jQuery);
